"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _EnterpriseEventBus = require("../services/EnterpriseEventBus");

var _EnterpriseEventBus2 = _interopRequireDefault(_EnterpriseEventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _previousIsDirty = void 0;

var DirtyFlagService = function () {
  function DirtyFlagService() {
    (0, _classCallCheck3.default)(this, DirtyFlagService);
  }

  (0, _createClass3.default)(DirtyFlagService, null, [{
    key: "setDirty",

    /**
     * Updates dirty flag to host
     * @param {boolean} dirty 
     */
    value: function setDirty(dirty) {
      if (_previousIsDirty === dirty) {
        return; // prevent unnecessary spamming
      }

      _previousIsDirty = dirty;

      _EnterpriseEventBus2.default.fire("setdirty", { dirty: dirty });
    }
  }]);
  return DirtyFlagService;
}();

exports.default = DirtyFlagService;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/DirtyFlagService.js
// module id = 810
// module chunks = 10